/**
 * Returns a random integer between 0 and the exclusive max.
 *
 * @param exclusiveMax {number} - The exclusive max of the random number
 * @returns 0 <= randomInt < exclusiveMax
 */
export const getRandomInt = (exclusiveMax: number) =>
  Math.floor(Math.random() * exclusiveMax);
